import React from "react";
import TextInput from "../common/inputs/textInput";
import Logo from "../../synaccess_white.svg";
import { Link } from "react-router-dom";
import parseQueryParam from "../../utils/parseQueryParams";
import "./login.css";

const passwordRequirements = [
  {
    name: "2 lowercase characters required",
    valid: (password) => /[a-z].*[a-z]/.test(password),
  },
  {
    name: "2 uppercase characters required",
    valid: (password) => /[A-Z].*[A-Z]/.test(password),
  },
  {
    name: "2 number characters required",
    valid: (password) => /[0-9].*[0-9]/.test(password),
  },
  {
    name: "2 special characters required",
    valid: (password) => /[!@#$%^&*;].*[!@#$%^&*;]/.test(password),
  },
];


export default class ResetPasswords extends React.Component {
  state = {
    email: "",
    submitted: false,
    passwordMode: false,
    password: "",
    confirmPassword: "",
    errorMsg: "",
    passwordChangeSuccess: false,
  }
  componentDidMount() {
    const { t } = parseQueryParam(this.props.history.location.search);
    if (t) {
      this.setState({
        passwordMode: true
      })
    }
  }
  sendResetEmail = () => {
    const email = this.state.email.trim();
    if (!email) {
      this.setState({
        errorMsg: "Email is required",
      });
      return;
    }

    this.setState({
      errorMsg: "",
    });

    this.props.submitForgottenPassEmail(email, (err) => {
      if (err) {
        this.setState({
          errorMsg: err.response?.data?.message || err.response?.data?.status || err.message || "Error sending reset email",
        });
        return;
      }

      this.setState({
        submitted: true,
      });
    });
  }
  resetPasswordButtonPress = () => {
    this.setState({
      errorMsg: "",
    })
    if (this.state.password === this.state.confirmPassword) {
      this.props.resetPassword({password: this.state.password}, (err, res) => {
        if (err) {
          this.setState({
            errorMsg: err.message
          })
        } else {
          if (res.data) {
            this.setState({
              passwordChangeSuccess: true
            })

          }
        }
      });
    } else {
      this.setState({
        errorMsg: "Passwords do not match"
      })
    }
  }

  renderError = () => {
    if (!this.state.errorMsg) {
      return null;
    }

    return (
      <div className="reset-password-card__error" role="alert">
        {this.state.errorMsg}
      </div>
    );
  }

  renderSubmitted = () => (
    <div className="login-card__surface reset-password-card__surface">
      <h1 className="login-card__header">
        Check your email for instructions to reset your password
      </h1>
      <p className="reset-password-card__body">
        If you haven't received your email in 5 minutes, check your spam or
        <button
          type="button"
          className="reset-password-card__inline-button"
          onClick={this.sendResetEmail}
        >
          resend
        </button>
      </p>
      {this.renderError()}
    </div>
  );

  renderPasswordChangeSuccess = () => (
    <div className="login-card__surface reset-password-card__surface">
      <h1 className="login-card__header">
        You've successfully changed your password
      </h1>
      <Link
        className="button login-card__submit reset-password-card__continue"
        to="/"
      >
        Continue
      </Link>
    </div>
  );

  renderPasswordRequirements = () => (
    <div className="reset-password-card__validation">
      {passwordRequirements.map((requirement) => {
        const valid = requirement.valid(this.state.password);

        return (
          <div
            key={requirement.name}
            className={`reset-password-card__validation-row ${
              valid ? "reset-password-card__validation-row--valid" : ""
            }`}
          >
            <i className="material-icons" aria-hidden="true">
              {valid ? "check" : "cancel"}
            </i>
            <span>{requirement.name}</span>
          </div>
        );
      })}
    </div>
  );

  renderResetForm = () => (
    <React.Fragment>
      <div className="login-card__surface reset-password-card__surface">
        <h1 className="login-card__header">Reset your password</h1>
        {this.state.passwordMode ? (
          <form
            className="reset-password-card__form"
            onSubmit={(event) => {
              event.preventDefault();
              this.resetPasswordButtonPress();
            }}
          >
            <TextInput
              label="Password"
              callback={(text) => this.setState({ password: text })}
              value={this.state.password}
              inputContainerStyle={{
                width: "100%",
              }}
              type="password"
            />
            <TextInput
              label="Confirm Password"
              callback={(text) => this.setState({ confirmPassword: text })}
              value={this.state.confirmPassword}
              inputContainerStyle={{
                width: "100%",
              }}
              type="password"
            />
            {this.renderPasswordRequirements()}
            {this.renderError()}
            <button className="button login-card__submit" type="submit">
              Reset Password
            </button>
          </form>
        ) : (
          <form
            className="reset-password-card__form"
            onSubmit={(event) => {
              event.preventDefault();
              this.sendResetEmail();
            }}
          >
            <p className="reset-password-card__body">
              Enter the email address associated with your account and we'll
              send you a link to reset your password.
            </p>
            <TextInput
              label="Email"
              callback={(text) => this.setState({ email: text })}
              value={this.state.email}
              inputContainerStyle={{
                width: "100%",
              }}
            />
            <button className="button login-card__submit" type="submit">
              Submit
            </button>
            {this.renderError()}
          </form>
        )}
        <div className="reset-password-card__return">
          <Link className="login-card__link" to="/login">
            Return to sign in
          </Link>
        </div>
      </div>
      <div className="login-card__footer">
        Don't have an account?{" "}
        <Link className="login-card__footer-link" to="/register">
          Sign up
        </Link>
      </div>
    </React.Fragment>
  );

  render() {
    return (
      <div className="background-gradient login-page reset-password-page">
        <div className="login-page__container">
          <div className="login-card reset-password-card">
            <div className="login-card__logo">
              <img alt="logo" src={Logo} width="165px" />
            </div>
            {this.state.submitted
              ? this.renderSubmitted()
              : this.state.passwordChangeSuccess
                ? this.renderPasswordChangeSuccess()
                : this.renderResetForm()}
          </div>
        </div>
      </div>
    )
  }
}
